import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KeyboardItemDirective } from './keyboard-item.directive';
import { KeyboardListNavigationArrowDirective } from './keyboard-list-navigation-arrow.directive';
import { KeyboardListNavigationTabDirective } from './keyboard-list-navigation-tab.directive';
import { KeyboardListDirective } from './keyboard-list.directive';
import { KeyboardSymbolSearchDirective } from './keyboard-symbol-search.directive';
import { KeyboardUtils } from './keyboard.utils';

/**
 * Dieser Modul umfasst alle Tastatunbezugliche Funktionalität.
 */
@NgModule({
    imports: [CommonModule],
    declarations: [
        KeyboardListDirective,
        KeyboardItemDirective,
        KeyboardListNavigationArrowDirective,
        KeyboardSymbolSearchDirective,
        KeyboardListNavigationTabDirective
    ],
    providers: [
        KeyboardUtils
    ],
    exports: [
        KeyboardListDirective,
        KeyboardItemDirective,
        KeyboardListNavigationArrowDirective,
        KeyboardListNavigationTabDirective,
        KeyboardSymbolSearchDirective
    ]
})
export class KeyboardModule {
}
